import React, { useEffect, useState } from "react";
//import Plotly from 'plotly.js-dist';
import createPlotlyComponent from "react-plotly.js/factory";
import { faFilter } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useUnitConversion, formatUnitAbbreviation } from '../../../utils/unitConversion';
import _ from 'lodash';
import { useStore } from '../../../providers/AppProvider';

const Plot = createPlotlyComponent(window.Plotly);

interface Props {
  passableKey:string,
  config: any,
  selectedLayerId: string | null,
  updateHistogramId: number,
  plotConfigs: any,
  updateId: number,
  dwFilters: any,
  setDwFilters: Function,
}

const HistogramPlot = ({ passableKey, config, selectedLayerId, updateHistogramId, plotConfigs, updateId, dwFilters, setDwFilters }: Props) => {

  console.log("040223 config", config)
  console.log("D112123 dwFilters", dwFilters)
  const { unitsConvert, convertToPreferredUnitValue } = useUnitConversion();
  const { localePreferences } = useStore();
  const volumemid = _.get(localePreferences, 'measureUnits.volume.mid');
  const preferredAreaAbbr: string = typeof volumemid === 'string' ? volumemid : volumemid?.abbr || 'ft3';
  const mid = _.get(localePreferences, 'measureUnits.length.mid');
  const preferredLenAbbr: string = typeof mid === 'string' ? mid : mid?.abbr || 'ac';
  useEffect(() => {
      console.log("040223 passableKey", passableKey);
      console.log("040223 plotConfigs", plotConfigs);
      console.log("040223 config", config);
      console.log("040223 updateId", updateId);
      console.log("040223 updateHistogramId", updateHistogramId);
      console.log("040223 selectedLayerId", selectedLayerId);
  }, [plotConfigs, updateId, config, updateHistogramId, selectedLayerId]);

  const removeFilter = (e:any) => {
    console.log("removeFilter e",e);
    console.log("removeFilter config",config);
    console.log("D112123 removeFilter dwFilters",dwFilters);
    let updatedDwFilter:any = {...dwFilters};
    Object.keys(dwFilters).forEach((key: string) => {
      console.log("D112122 key", key);
      console.log("D112122 config.name", config.name);
      if (config.title === key){
        console.log("removing filter dwFilters[key]",dwFilters[key]);
        delete updatedDwFilter[key];
      }
      if (key === "version"){
        updatedDwFilter[key] = (updatedDwFilter[key] ? parseInt(updatedDwFilter[key]) + 1 : 0).toString();
      }
    })
    console.log("removeFilter updatedDwFilter",updatedDwFilter);
    setDwFilters(updatedDwFilter);

  }
  function graphHover(params:any) {
    console.log("x040223 params", params);
      if(params.points.length > 0) {
        params.event.target.style.cursor = 'pointer';
      }else {
        params.event.target.style.cursor = '';
      }
  }
  console.log("090525 config", config);
  console.log("090525 preferredLenAbbr", preferredLenAbbr);
  console.log("090525 preferredAreaAbbr", preferredAreaAbbr);
  console.log("090525 localePreferences", localePreferences);
  var colors = null;
  var _data = config?.data;
  // Convert numeric data from meters to preferred length unit if needed (and not categorical)
  if (preferredLenAbbr !== 'm' && Array.isArray(_data)) {
    if (config?.title === "Plant Height"){
      _data = _data.map((x: any) => {
        const val = typeof x === 'number'
          ? x
          : (typeof x === 'string' && x.trim() !== '' && !isNaN(Number(x)) ? Number(x) : x);
        return typeof val === 'number' ? convertToPreferredUnitValue(val, 'm', 'length', 'mid') : x;
      });
    }
  }
  if (preferredAreaAbbr !== 'm3' && Array.isArray(_data)) {
    if (config?.title === "Canopy Volume"){
      _data = _data.map((x: any) => {
        const val = typeof x === 'number'
          ? x
          : (typeof x === 'string' && x.trim() !== '' && !isNaN(Number(x)) ? Number(x) : x);
        return typeof val === 'number' ? convertToPreferredUnitValue(val, 'm3', 'volume', 'mid') : x;
      });
    }
  }/**/

  if (config.categoryColors){
    let _data_ = config.data.sort().reverse();
    let uniqueValues = _data_.filter(function(value:string, index:number, array:any ) {
      return array.indexOf(value) === index;
    })
    console.log("041023 uniqueValues", uniqueValues);
    let alternateNumber = 0;
    colors = uniqueValues.map(function(x:string) {
      //console.log("C112123 x", x);
      //console.log("C112123 config.categoryColors", config.categoryColors);
      //console.log("C112123 config.categoryColors[x]", config.categoryColors[x]);
      var color = null;
      if (config.categoryColors[x]){
        color = config.categoryColors[x].rgb;
     }else{
        color = config.categoryColors.Alternates.rgb[alternateNumber] ? config.categoryColors.Alternates.rgb[alternateNumber] : 'grey'; // use 'grey' as default color if key not found
        alternateNumber++;
      }
      return color;  
    })
    _data = _data_.map((color:string) => {
      let returnable = color;
      if (color === "Yellow"){ returnable = "Baseline"};
      if (color === "Green"){ returnable = "Modified"};
      if (color === "Blue"){ returnable = "Improved"};
      if (color === "White"){ returnable = "MyAlmonds"};
      if (color === "Black"){ 
        if(config.title === "Treatment Color"){
          returnable = "NoTreatment"
        }else{
          returnable = "N/A"
        }
      };
      return returnable;
    });
  }
  console.log("041023 _data", _data);
  console.log("C112123 colors", colors);
    var trace = {
        x: _data ? _data : null, //[1,2,3,4,5,6,7,8,9,10] 
        //y: x,
        type: 'histogram',
        histfunc:'count',
        marker: {
          color: colors
        },
        nbinsx: 10,
      };
    var data = [trace]
    return (
      <>
      {
        //config &&
        <div>
        { dwFilters[config.title]
        ? <div 
            title="Remove filter"
            className={"clearFilter"}
            onClick={(e:any) => (removeFilter(e))}
          >
            <div className={"rotateSlash"} style={{backgroundColor:"#6d757d"}}></div>
            <FontAwesomeIcon icon={faFilter} />
          </div>
        : <></>
        }
        <Plot
            key={passableKey}
            config={{
              displayModeBar: false,
              //responsive: true
            }}            
            data={data}//{config.traces}
            //layout={config.layout}
            layout={{
              hovermode:"closest",  //"x unified",
              margin: {
                  t: 20,
                  b: 40,
                  l: 35,
                  r: 5
              },
              font: {
                size: 8,
              },
              bargap: 0.05, 
              bargroupgap: 0.2, 
              title: config ? `${config.title}` : "...loading", 
              xaxis: {
                title: config?.status?.data ? "" : (config ? config.title : "...loading"),
                tickfont: {
                  size: config?.title === "Treatment Color" ? 6.5 : 8,
                }
              }, 
              yaxis: {
                title: `${config.entity.charAt(0).toUpperCase() + config.entity.slice(1)} Count`
              },
              autosize: true,
              plot_bgcolor:"#ffffff00",
              paper_bgcolor:"#ffffff00"
            }}
            //useResizeHandler={true}
            //style={{width: "100%", height: "100%"}}
            style={{
              width: "240px", 
              height: "130px"
            }}
            onHover={(params:any) => graphHover(params)}
            onSelected={(params: any) => console.log("x040223 params", params)}
            onDeselect={() => console.log("x040223 onDeselect")}
            onClick={(params: any) => {
              console.log("x040223 params", params)
              if(params.points.length /*&& onClick*/) {
                // convert the clicked poisition to data position
                const bb = params.event.target.getBoundingClientRect();
                const y = params.points[0].yaxis.p2d(params.event.clientY - bb.top);
                const x = params.points[0].yaxis.p2d(params.event.clientX - bb.left);
                console.log("x040223 bb", bb);
                console.log("x040223 y", y);
                console.log("x040223 x", x);
                console.log("x040223 params", params);
                console.log("x040223 params.points[0].data.x", params.points[0].data.x);
                console.log("x040223 params.points[0].fullData.xbins", params.points[0].fullData.xbins);
                console.log("x040223 params.points[0].binNumber", params.points[0].binNumber);
                const xbins = params.points[0].fullData.xbins;
                const binNumber = params.points[0].binNumber;
                const minBin = xbins.start + (xbins.size * binNumber); 
                const maxBin = minBin + xbins.size; 
                const selectionRange = [minBin,maxBin];
                console.log("x040223 selectionRange", selectionRange);
                //console.log("110722 Math.max(params.points[0].data.x)", Math.max(...params.points[0].data.x));
                //console.log("110722 Math.min(params.points[0].data.x)", Math.min(...params.points[0].data.x));
                //let ids = params.points.map((param: any) => {
                //  console.log("110722 param", param);
                //  return parseInt(param.data); // will be the entity id
                //});
                console.log("x040223 config", config);
                //onClick(y);
                setDwFilters((prevState:any) => {
                  let newState = {...prevState};
                  newState[config.title] = {
                      selectionRange,
                      config
                  }
                  newState["version"] = (newState["version"] ? parseInt(newState["version"]) + 1 : 0).toString();
                  return newState
                }
                )
              }
            }}
        />
        </div>
      }
      </>
    );
}


export default HistogramPlot;